var React = require('react');

function IconHalfAndHalf (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M56 32C56 18.75 45.25 8 32 8V56C45.25 56 56 45.25 56 32ZM0 32C0 23.5131 3.37142 15.3737 9.37258 9.37258C15.3737 3.37142 23.5131 0 32 0C40.4869 0 48.6263 3.37142 54.6274 9.37258C60.6286 15.3737 64 23.5131 64 32C64 40.4869 60.6286 48.6263 54.6274 54.6274C48.6263 60.6286 40.4869 64 32 64C23.5131 64 15.3737 60.6286 9.37258 54.6274C3.37142 48.6263 0 40.4869 0 32Z","fill":"currentColor"}));
}

IconHalfAndHalf.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = IconHalfAndHalf;

IconHalfAndHalf.default = IconHalfAndHalf;
